import { useEffect } from 'react';
import * as Chat from '@lib/Chat';

export const useChat = ({ role }) => {
  useEffect(() => {
    if (!role) return;
    Chat.init({ role });
  }, [role]);
};
